<template>
  <div class="shortlist">
    <second-menu-link-content>
      <template v-slot:header>
        <span class="title" @click="toBiddingActivities">
          活动竞价/
        </span>入围确认
      </template>
      <template v-slot:content>
        <div class="main" ref="baseInfo">
          <div class="flex">
            <div class="flex-left">
              <div class="table-img">
                <el-table
                  :data="commodityList"
                  style="width: 100%"
                  ref="flexRightTable"
                >
                  <el-table-column label="商品名称">
                    <template slot-scope="props">
                      <div class="name-norm-container">
                        <div class="name-price">
                          <div class="good-name">
                            {{ props.row.goodsName }}
                          </div>
                        </div>
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
                  <el-table-column label="竞价金额" prop="biddingPrice"></el-table-column>
                  <el-table-column label="操作" width="80" align="center">
                    <template slot-scope="props">
                      <el-button
                        class="btn-text"
                        type="text"
                        @click="selectGoodInDialog(props.row)"
                        >选择</el-button
                      >
                    </template>
                  </el-table-column>
                </el-table>
                <div class="table_pagination">
                  <pagination-tpl
                    :total="goodsTotal"
                    :currentPage="goodsCurrentPage"
                    @queryChange="onGoodsCurrPageChange"
                  ></pagination-tpl>
                </div>
              </div>
            </div>
            <div class="flex-right">
              <div class="img">
                <img src="../../../../assets/shortlist/arrow.png">
              </div>
              <div class="table-img">
                <el-table
                  :data="tmpShowSelectedGoodList"
                  style="width: 100%"
                  row-key="id"
                >
                  <el-table-column label="商品名称">
                    <template slot-scope="scope">
                      <div class="flex-right-good-name">
                        {{ scope.row.goodsName }}
                      </div>
                    </template>
                  </el-table-column>
                  <el-table-column label="供应商名称" prop="supplierName"></el-table-column>
                  <el-table-column label="竞价金额" prop="biddingPrice"></el-table-column>
                  <el-table-column label="权重" type="index" width="180"></el-table-column>
                  <el-table-column width="100">
                    <template slot="header">
                      <span>操作</span>
                      <el-tooltip content="鼠标长按可拖拽上下排序权重" placement="bottom" effect="light" popper-class="draw_share_atooltip">
                        <img class="table-head-img" src="../../../../assets/bidding/title.png">
                      </el-tooltip>
                    </template>
                    <template slot-scope="scope">
                      <div
                        class="delete-btn"
                        @click="deleteGoodInDialog(scope.row)"
                      >
                        删除
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="bottom">
            <div class="operations" ref="operations">
              <el-button class="btn-white" @click="cancel">返回</el-button>
              <el-button class="btn-blue" @click="preservation"
                >保存</el-button
              >
            </div>
          </div>
        </div>
      </template>
    </second-menu-link-content>
  </div>
</template>

<script>
import SecondMenuLinkContent from 'components/layout/SecondMenuLinkContent';
import PaginationTpl from 'base/PaginationTpl';
import Sortable from 'sortablejs';
import DBCommodity from "models/db/commodity.js";
import DBBiddingActivities from "models/db/biddingActivities.js";
const dbBiddingActivities = new DBBiddingActivities();
const dbCommodity = new DBCommodity();
export default {
  data() {
    return {
      // 展示的商品列表
      commodityList: [],
      // 商品列表总数
      goodsTotal: 0,
      goodsCurrentPage: 1,
      // 编辑时将要添加的商品
      tmpSelectedGoodList: [],
      tmpShowSelectedGoodList: [],
      id: '' //竞价活动id
    };
  },
  methods: {
    toBiddingActivities() {
      this.$router.push(
        "/admin/marketing/bidding-activities/biddingActivities"
      );
    },
    cancel() {
      this.$router.go(-1);
    },
    // 保存
    preservation() {
      this.$confirm("发布后将无法更改，是否确认发布?", "确认发布", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        customClass: 'publish-messageBox',
        confirmButtonClass: 'btn-blue',
        cancelButtonClass: 'btn-white',
      })
        .then(() => {
          if (this.tmpShowSelectedGoodList.length != 0) {
            let data = {}
            data.id = Number(this.id)
            data.list = []
            this.tmpShowSelectedGoodList.map((i,index) => {
              let obj = {}
              obj.id = i.id
              if (i.weight) {
                obj.weight = i.weight
              } else {
                obj.weight = index + 1
              }
              data.list.push(obj)
            })
            dbBiddingActivities.getDBActivityShortList(data).then(res => {
              if (res.success) {
                this.$message({
                  message: '发布成功',
                  type: "success",
                });
                this.$router.go(-1)
              } else {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }
            })
          } else {
            this.$message({
              message: '请先选择商品',
              type: "error",
            });
          }
        })
    },
    // 获取商品列表
    _getCommodityListWithNorm() {
      let id = this.id
      let currentPage = this.goodsCurrentPage
      let isPass = 1
      dbBiddingActivities.getDBActivityDetail(id, currentPage, isPass).then(res => {
        if (res.success) {
          this.goodsTotal = res.result.totalNum;
          let arr = []
          res.result.items.map(i => {
            let obj = {}
            obj.id = i.id
            obj.goodsName = i.goodsName
            obj.supplierName = i.supplierName
            obj.biddingPrice = i.biddingPrice
            arr.push(obj)
          })
          this.commodityList = arr
        } else {
          this.$message({
            message: res.message,
            center: true,
            type: "error",
            duration: 1000,
          });
        }
      })
    },
    // 商品列表弹框--选择商品
    selectGoodInDialog(good) {
      const _good = JSON.parse(JSON.stringify(good));
      console.log("选择的商品", good);
      console.log("此时的临时商品列表--", this.tmpSelectedGoodList);
      const found = this.tmpSelectedGoodList.find(
        (item) => item.id === _good.id
      );
      if (found === undefined) {
        this.tmpSelectedGoodList.push(_good);
        this.tmpShowSelectedGoodList = this.tmpSelectedGoodList
      } else {
        this.$message({
          message: "该商品已添加",
          type: "error",
        });
      }
    },
    // 商品列表翻页
    onGoodsCurrPageChange(option) {
      this.goodsCurrentPage = option.currentPage
      this._getCommodityListWithNorm();
    },
    // 商品列表弹框--删除商品
    deleteGoodInDialog(good) {
      const targetIndex = this.tmpSelectedGoodList.findIndex(
        (item) => item.id === good.id
      );
      this.tmpSelectedGoodList.splice(targetIndex, 1);
    },
    //行拖拽
    drag() {
      const el = document.querySelectorAll(
        ".el-table__body-wrapper > table > tbody"
      )[1];
      Sortable.create(el, {
        disabled: false, // 拖拽不可用? false 启用
        ghostClass: 'sortable-ghost', //拖拽样式
        animation: 150, // 拖拽延时，效果更好看
        onEnd: (e) => { // 拖拽结束时的触发
          let arr = this.tmpShowSelectedGoodList; // 获取表数据
          arr.splice(e.newIndex, 0, arr.splice(e.oldIndex, 1)[0]); // 数据处理，获取最新的表格数据
          arr.map((item,index) => {
            item.weight = index+1
          })
          this.tmpShowSelectedGoodList= arr;
        },
      })
    },
  },
  created() {
    this.id = this.$route.query.id
    this._getCommodityListWithNorm()
  },
  mounted() {
    this.drag()
    const paddingWidth = 46;
    this.$refs.operations.style.width =
      this.$refs.baseInfo.clientWidth + paddingWidth + 'px';
    window.onresize = () => {
      this.$refs.operations.style.width =
        this.$refs.baseInfo.clientWidth + paddingWidth + 'px';
    };
  },
  components: {
    SecondMenuLinkContent,
    PaginationTpl
  }
};
</script>

<style lang="scss" scoped>
.shortlist {
  width: 100%;
  height: 100%;
  font-size: 14px;
  color: rgba(96, 98, 102, 1);
  .title {
    color: rgba(61, 116, 242, 0.75);
    cursor: pointer;
    &:hover {
      color: rgba(61, 116, 242, 1);
    }
  }
  .content {
    .main {
      .flex {
        display: flex;
        justify-content: space-between;
        height: 100%;
        .flex-left {
          width: 40%;
          box-sizing: border-box;
          .table_pagination {
            display: flex;
            justify-content: flex-end;
          }
        }
        .flex-right {
          display: flex;
          width: 60%;
          box-sizing: border-box;
          .flex-right-good-name {
            box-sizing: border-box;
            width: 170px;
            padding-right: 10px;
            padding-left: 10px;
            text-overflow: -o-ellipsis-lastline;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .flex-right-norm-desc {
            box-sizing: border-box;
            padding-right: 10px;
            width: 220px;
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
          }
          .flex-right-good-price {
            box-sizing: border-box;
            padding-right: 10px;
            width: 62px;
          }
          .specifications {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 16px;
            .specifications-left {
              display: flex;
              align-items: center;
              .specifications-title {
                line-height: 32px;
                display: flex;
                align-items: center;
              }
              .specifications-list {
                display: flex;
                margin-left: 6px;
                .specifications-label {
                  max-width: 68px;
                  line-height: 32px;
                  white-space: nowrap;
                  text-overflow: ellipsis;
                  overflow: hidden;
                }
                .el-select {
                  width: 80px;
                }
              }
            }
            .el-button {
              width: 50px;
              padding: 0;
            }
          }
          .table-img {
            flex: 1;
          }
          .img {
            display: flex;
            align-items: center;
            height: calc(100% - 52px);
            margin-right: 26px;
            margin-left: 26px;
            img {
              width: 24px;
              height: 20px;
            }
          }
        }
      }
    }
  }
  .bottom {
    height: 40px;
    .operations {
      z-index: 10;
      height: 60px;
      position: fixed;
      left: 260px;
      bottom: 0;
      display: flex;
      justify-content: center;
      align-items: center;
      background: rgba(255, 255, 255, 1);
      box-shadow: 0px 0px 6px 0px rgba(219, 223, 230, 1);
      .el-button {
        width: 96px;
        letter-spacing: 4px;
      }
      .el-button + .el-button {
        margin-left: 24px;
      }
    }
  }
}
</style>
<style lang="scss">
.shortlist {
  .table-img {
    .el-table {
      .el-table__header-wrapper {
        .el-table__header {
          .has-gutter {
            tr {
              th {
                font-family: "SimSun";
              }
            }
          }
        }
      }
      .el-table__body-wrapper {
        .el-table__body {
          tbody {
            tr {
              td {
                .cell {
                  font-family: "SimSun";
                }
              }
            }
          }
        }
      }
    }
  }
  /* 左边的表格 */
  .flex-left {
    .table-img {
      .el-table {
        .el-table__header-wrapper {
          .el-table__header {
            .has-gutter {
              tr {
                th {
                  height: 32px;
                  .cell {
                    padding: 0;
                  }
                }
              }
            }
          }
        }
        .el-table__body-wrapper {
          .el-table__body {
            tbody {
              tr {
                padding: 0;
                td {
                  padding: 0;
                  .cell {
                    box-sizing: border-box;
                    padding: 0;
                    .name-norm-container {
                      width: 100%;
                      display: flex;
                      flex-direction: column;
                      .name-price {
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                        .good-name {
                          height: 32px;
                          display: flex;
                          align-items: center;
                          font-size: 12px;
                          white-space: nowrap;
                          overflow: hidden;
                          text-overflow: ellipsis;
                          flex: 1;
                        }
                        .good-price {
                          width: 80px;
                          padding-left: 16px;
                        }
                      }
                      .outside-container {
                        width: 100%;
                        height: 36px;
                        display: flex;
                        flex-direction: row;
                        justify-content: flex-start;
                        flex-wrap: wrap;
                        padding-bottom: 10px;
                        .inner-container {
                          margin-right: 6px;
                        }
                      }
                    }
                  }
                  &:first-child {
                    .cell {
                      padding-left: 20px;
                    }
                  }
                  &:last-child {
                    .cell {
                      display: flex;
                      justify-content: center;
                      align-items: center;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  /* 右边的表格 */
  .flex-right {
    .table-img {
      .el-table {
        .el-table__header-wrapper {
          .el-table__header {
            .has-gutter {
              tr {
                th {
                  height: 32px;
                  .cell {
                    padding: 0;
                  }
                }
                th:first-child {
                  .cell {
                    padding-left: 10px;
                  }
                }
              }
            }
          }
        }
        .el-table__body-wrapper {
          .el-table__body {
            tbody {
              tr {
                min-height: 32px;
                padding: 0;
                td {
                  min-height: 32px;
                  padding: 0;
                  .cell {
                    min-height: 32px;
                    padding: 10px 0;
                    .delete-btn {
                      cursor: pointer;
                      height: 12px;
                      color: #3d74f2;
                      font-size: 12px;
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  .table-head-img {
    width: 16px;
    height: 16px;
    cursor: pointer;
    margin-bottom: 4px;
    margin-left: 7px;
  }
}
</style>
<style>
.publish-messageBox .el-message-box__header {
  border-bottom: 1px solid #eee;
  padding-bottom: 15px;
}
.draw_share_atooltip{
  border: 1px solid #EEEEEE!important;
  box-shadow: 0px 2px 4px 0px rgba(35, 52, 70, 0.1);
  border-radius: 2px;
}
.draw_share_atooltip[x-placement^=bottom] .popper__arrow{
  border-bottom-color: #fff !important;
}
.draw_share_atooltip[x-placement^=bottom] .popper__arrow::after {
  border-bottom-color: #fff !important;
}
</style>